<nb-card>
    <nb-card-header>
        <div class="row align-items-center">
            <div class="col-10">My transactions</div>
            <div class="col-2">
                <button
                    fullWidth
                    nbButton
                    size="small"
                    status="danger"
                    (click)="onClose()"
                >
                    CLOSE
                </button>
            </div>
        </div>
    </nb-card-header>
    <nb-card-body>
        <div class="row">
            <div class="col-12">
                <ng2-smart-table
                    class="my-table"
                    [settings]="settings"
                    [source]="source"
                    (custom)="onView($event)"
                ></ng2-smart-table>
                <!-- <ngx-datatable
                    [rows]="transactions"
                    [columnMode]="ColumnMode.force"
                    [headerHeight]="50"
                    [footerHeight]="50"
                    [limit]="10"
                >
                    <ngx-datatable-column prop="txHash">
                        <ng-template
                            let-column="column"
                            ngx-datatable-header-template
                        >
                            Tx. hash</ng-template
                        >
                        <ng-template
                            let-value="value"
                            ngx-datatable-cell-template
                        >
                            {{ value.slice(0, 10) + "..." + value.slice(-10) }}
                        </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column prop="updatedAt">
                        <ng-template
                            let-column="column"
                            ngx-datatable-header-template
                            >Date</ng-template
                        >
                        <ng-template
                            let-value="value"
                            ngx-datatable-cell-template
                        >
                            {{
                                value | date : "MMM dd, yyyy, hh:mm:ss"
                            }}</ng-template
                        >
                    </ngx-datatable-column>
                    <ngx-datatable-column prop="amount">
                        <ng-template
                            let-column="column"
                            ngx-datatable-header-template
                            >Amount</ng-template 
                        >
                        <ng-template
                            let-value="value"
                            ngx-datatable-cell-template
                        >
                            {{ value | number }} ${{ tokenSymbol }}</ng-template
                        >
                    </ngx-datatable-column>
                </ngx-datatable> -->
            </div>
        </div>
        <div class="row" *ngIf="totalAmount && transactions.length > 0">
            <div class="col-6">
                <h4 class="mb-0">Total amount</h4>
                <h3>{{ totalAmount | number }} ${{ tokenSymbol }}</h3>
            </div>
        </div>
        <div class="row" *ngIf="!totalAmount || transactions.length == 0">
            <div class="col-12">
                <h4>There are no transactions for your wallet.</h4>
            </div>
        </div>
    </nb-card-body>
</nb-card>
